const typ = { t: 'Typ', name: 'typ', hint: { url: '/type/trailer', select: true }}
export default typ